import { useTheme } from "@hooks";

export const InvalidCross = () => {
  const { theme } = useTheme();

  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" width="16" height="16" rx="8" fill={theme.validator.invalid} />
      <path
        d="M5.31454 11.7648L4.73535 11.1856L7.92087 8.00006L4.73535 4.81454L5.31454 4.23535L8.50006 7.42087L11.6856 4.23535L12.2648 4.81454L9.07924 8.00006L12.2648 11.1856L11.6856 11.7648L8.50006 8.57924L5.31454 11.7648Z"
        fill="#F4F1F2"
      />
    </svg>
  );
};
